<template>
  <div class="mb-15">
    <v-progress-linear
      v-if="!placementSetting"
      indeterminate
      color="primary"
    ></v-progress-linear>

    <template v-else>
      <div class="my-4">
        <h2 class="mb-2">{{ $t('workScheduling.placementSetting.section1.title') }}</h2>
        <div class="setting-table-row">
          <div class="header cell-label age">{{ $t('workScheduling.placementSetting.section1.age') }}</div>
          <div class="header cell-label setting">{{ $t('workScheduling.placementSetting.section1.setting') }}</div>
          <div class="header cell-label calc">{{ $t('workScheduling.placementSetting.section1.formula') }}</div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.age0') }}</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.staffLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age0"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.perLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age0"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.childrenLabel') }}
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.childCountLabel') }} × {{ placementSetting.perChildren.age0 }} / {{ placementSetting.perStaff.age0 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.age1') }}</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.staffLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age1"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.perLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age1"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.childrenLabel') }}
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.childCountLabel') }} × {{ placementSetting.perChildren.age1 }} / {{ placementSetting.perStaff.age1 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.age2') }}</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.staffLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age2"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.perLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age2"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.childrenLabel') }}
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.childCountLabel') }} × {{ placementSetting.perChildren.age2 }} / {{ placementSetting.perStaff.age2 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.age3') }}</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.staffLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age3"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.perLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age3"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.childrenLabel') }}
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.childCountLabel') }} × {{ placementSetting.perChildren.age3 }} / {{ placementSetting.perStaff.age3 }}
            </div>
          </div>
        </div>

        <div class="setting-table-row border">
          <div class="setting-cell cell-label age">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.age4Plus') }}</div>
          </div>
          <div class="setting-cell cell-label setting">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.staffLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.perChildren.age4"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.perLabel') }}
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  v-model="placementSetting.perStaff.age4"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section1.childrenLabel') }}
            </div>
          </div>
          <div class="setting-cell cell-label calc">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.childCountLabel') }} × {{ placementSetting.perChildren.age4 }} / {{ placementSetting.perStaff.age4 }}
            </div>
          </div>
        </div>

        <div class="per-age-round-row">
          <div class="per-age-round-row-header">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section1.commonCalc') }}</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              {{ $t('workScheduling.placementSetting.section1.decimalPoint') }}
              <span>
                <v-select
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 160px;"
                  class="mx-2"
                  v-model="placementSetting.roundingPerAge.decimalPlaces"
                  :items="[
                    { value: 1, title: $t('workScheduling.placementSetting.section1.decimalFirst') },
                    { value: 2, title: $t('workScheduling.placementSetting.section1.decimalSecond') },
                  ]"
                  color="primary"
                ></v-select>
              </span>
              <span>
                <v-select
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 160px;"
                  class="mx-2"
                  v-model="placementSetting.roundingPerAge.action"
                  :items="[
                    { value: 'down', title: $t('workScheduling.placementSetting.section1.roundDown') },
                    { value: 'normal', title: $t('workScheduling.placementSetting.section1.roundNormal') },
                    { value: 'up', title: $t('workScheduling.placementSetting.section1.roundUp') },
                  ]"
                  color="primary"
                ></v-select>
              </span>
            </div>
          </div>
        </div>

        <h2 class="mb-2 mt-16">{{ $t('workScheduling.placementSetting.section2.title') }}</h2>
        <div class="setting-texts bold mb-4">
          {{ $t('workScheduling.placementSetting.section2.description') }}
          <span>
            <v-select
              variant="outlined"
              density="compact"
              hide-details
              style="width: 160px;"
              class="mx-2"
              v-model="placementSetting.roundingAll.action"
              :items="[
                { value: 'down', title: $t('workScheduling.placementSetting.section1.roundDown') },
                { value: 'normal', title: $t('workScheduling.placementSetting.section1.roundNormal') },
                { value: 'up', title: $t('workScheduling.placementSetting.section1.roundUp') },
              ]"
              color="primary"
            ></v-select>
          </span>
          {{ $t('workScheduling.placementSetting.section2.additionalFormula') }}
        </div>
        <p class="setting-texts">{{ $t('workScheduling.placementSetting.section2.minimumNote') }}</p>

        <h2 class="mb-2 mt-16">{{ $t('workScheduling.placementSetting.section3.title') }}</h2>
        <div class="per-age-round-row">
          <div class="per-age-round-row-header">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section3.additionalStaff') }}</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              <span>
                <v-text-field
                  variant="outlined"
                  density="compact"
                  hide-details
                  style="width: 60px;"
                  class="mx-2"
                  type="number"
                  v-model="placementSetting.additional.staffCount"
                  color="primary"
                />
              </span>
              {{ $t('workScheduling.placementSetting.section3.staffCount') }}
            </div>
          </div>
          <div class="per-age-round-row-header">
            <div class="setting-texts">{{ $t('workScheduling.placementSetting.section3.range') }}</div>
          </div>
          <div class="per-age-round-row-cell">
            <div class="setting-texts">
              <span style="width: 300px;">
                <hour-minute-input v-model="placementSetting.additional.startMin" />
              </span>
              <span class="mx-2" style="width: 40px;">{{ $t('workScheduling.placementSetting.section3.from') }}</span>
              <span style="width: 300px;">
                <hour-minute-input v-model="placementSetting.additional.endMin" />
              </span>
            </div>
          </div>
        </div>
      </div>

      <template v-if="showHourlyWageForSpecialCareSection">
      <h2 class="mb-2 mt-16">{{ $t('workScheduling.placementSetting.section4.title') }}</h2>
      <div class="per-age-round-row" style="gap: 1rem;">
        <div class="per-age-round-row-header">
          <div class="setting-texts">{{ $t('workScheduling.placementSetting.section4.hourlyWage') }}</div>
        </div>
        <div style="width: 240px;">
          <v-text-field 
            density="compact"
            hide-details
            variant="outlined"
            :suffix="$t('workScheduling.placementSetting.section4.yen')"
            v-model="placementSetting.subsidyChildcare.hourlyWageAmount"
            type="number"
            color="primary"
          />
        </div>
      </div>
      </template>

      <v-progress-linear
        v-if="isUpdating"
        class="my-2"
        indeterminate
        color="primary"
      ></v-progress-linear>
      
      <div class="d-flex mt-16">
        <v-spacer />
        <v-btn
          size="large"
          variant="flat"
          color="primary"
          @click="updatePlacementSetting"
        >{{ $t('workScheduling.placementSetting.save') }}</v-btn>
        <v-spacer />
      </div>
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import HourMinuteInput from '@/components/molecules/HourMinuteInput.vue'
import { WorkSchedulePlacementSettingResponse } from 'chaild-api/lib';
import ApiWorkSchedule from '@/api/ApiWorkSchedule'
import LocalDataService from '@/service/LocalDataService';

interface DataType {
  placementSetting: WorkSchedulePlacementSettingResponse | null;
  isUpdating: boolean;
  showHourlyWageForSpecialCareSection: boolean;
}

export default defineComponent({
  components: {
    HourMinuteInput
  },
  data: (): DataType => ({
    placementSetting: null,
    isUpdating: false,
    showHourlyWageForSpecialCareSection: false,
  }),
  methods: {
    async getPlacementSetting() {
      const nurseryId = LocalDataService.getNurseryId()

      if (nurseryId) {
        const response = await ApiWorkSchedule.getPlacementSetting({ nurseryId })
        if (response) {
          this.placementSetting = response
        }
      }
    },
    async updatePlacementSetting() {
      const nurseryId = LocalDataService.getNurseryId()

      if (nurseryId && this.placementSetting) {
        this.isUpdating = true
        const response = await ApiWorkSchedule.updatePlacementSetting({
          nurseryId,
          body: this.placementSetting
        })
        this.isUpdating = false

        if (response) {
          this.placementSetting = response
        }
      }
    }
  },
  mounted() {
    this.getPlacementSetting()
  }
})
</script>

<style lang="scss" scoped>
.cell-label {
  font-size: 14px;
  &.header {
    font-weight: bold;
  }
}

.setting-table-row {
  display: flex;
  width: 100%;

  &.border {
    border-bottom: solid 1px #e0e0e0;
  }
}

.header {
  background-color: #f0f0f0;
  padding: 4px 8px;
  border-right: solid 1px #c0c0c0;

  &.age {
    width: 120px;
  }

  &.setting {
    flex: 1;
  }

  &.calc {
    width: 240px;
  }
}

.setting-cell {
  border-right: solid 1px #e0e0e0;
  padding: 16px 8px;

  &.age {
    width: 120px;
  }

  &.setting {
    flex: 1;
  }

  &.calc {
    width: 240px;
  }
}

.setting-texts {
  display: flex;
  align-items: center;
  height: 100%;
}

.per-age-round-row {
  display: flex;
  margin: .5rem 0;
}

.per-age-round-row-header {
  background-color: #f0f0f0;
  padding: 0.5rem 1rem;
  font-size: 14px;
  font-weight: bold;
}

.per-age-round-row-cell {
  padding: 0.5rem 1rem;
  font-size: 14px;
}

.bold {
  font-weight: bold;
}
</style>